import ee from 'event-emitter';
import { getGameSize } from './utils';
import { Orientation } from './utils/detectOrientation';

const put: HTMLAudioElement = new Audio('./sounds/put.mp3');
const get: HTMLAudioElement = new Audio('./sounds/get.mp3');
const scored: HTMLAudioElement = new Audio('./sounds/scored.mp3');
const win: HTMLAudioElement = new Audio('./sounds/win.mp3');
const shuffle: HTMLAudioElement = new Audio('./sounds/shuffle.mp3');
win.volume = 0.2;

type global = {
  size: (orientation?: Orientation | void) => number;
  images: { [index: string]: HTMLImageElement };
  getStage(): any;
  ee: any;
  volume: boolean;
  sounds: {
    put: () => void;
    get: () => void;
    scored: () => void;
    win: () => void;
    shuffle: () => void;
  };
  playWinAnimation: () => Promise<void>;
};

const global: global = {
  ee: () => {},
  size: () => getGameSize(),
  images: {},
  getStage: () => {},
  playWinAnimation: async () => {},
  volume: !localStorage.getItem('volumeOff'),
  sounds: {
    put: () => {
      if (!global.volume) return Promise.resolve();
      return put.play();
    },
    get: () => {
      if (!global.volume) return Promise.resolve();
      return get.play();
    },
    scored: () => {
      if (!global.volume) return Promise.resolve();
      return scored.play();
    },
    shuffle: () => {
      if (!global.volume) return Promise.resolve();
      return shuffle.play();
    },
    win: async () => {
      if (!global.volume) return Promise.resolve();
      return win.play();
    },
  },
};

ee(global.ee);

export default global;
